module.exports = __webpack_public_path__ + "assets/img/add_json.918cd96a.png";